<mat-form-field appearance="outline" class="full-width">
  <mat-label>{{ label }}</mat-label>
  <input matInput
         [formControl]="searchControl"
         [matAutocomplete]="clientAuto"
         [placeholder]="placeholder"
         [required]="required"
         (blur)="onTouched()">
  <mat-icon matSuffix>search</mat-icon>
  <mat-autocomplete #clientAuto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
    <mat-option *ngFor="let c of filteredClients$ | async" [value]="c">
      @if (c.middle_name) {
        {{ c.last_name }} {{ c.first_name }} {{ c.middle_name }} — {{ c.phone }}
      } @else {
        {{ c.last_name }} {{ c.first_name }} — {{ c.phone }}
      }
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="showServerError()">{{ serverError() }}</mat-error>
</mat-form-field>

<button mat-stroked-button type="button" class="full-width-btn" routerLink="/clients/new">
  <mat-icon>person_add</mat-icon> Новый клиент
</button>
